import React, { useState } from 'react';
import { imageAssetUrl } from '../contentUrls';

export default function Schedule() {
  const [activeTab, setActiveTab] = useState('saturday');

  const scheduleDays = [
    {
      id: 'saturday',
      tabLabel: 'Saturday',
      title: 'SATURDAY, MAY 16:',
      events: [
        'DOORS - NOON',
        '2:30pm - Small Colour Tattoo',
        '3:30pm - Medium Black & Grey Tattoo',
        '5pm - Large Colour Tattoo',
        '7pm - Colour Sleeve',
        '9:30pm - TATTOO of DAY - Sponsored by GOOD GUY SUPPLIES',
      ],
      note: '(Tattoo must be started and finished that day)',
    },
    {
      id: 'sunday',
      tabLabel: 'Sunday',
      title: 'SUNDAY, MAY 17:',
      events: [
        'DOORS - NOON',
        '2:30pm - Small Black & Grey Tattoo',
        '3:30pm - Medium Colour Tattoo',
        '5pm - Large Black & Grey Tattoo',
        '7pm - Black & Grey Sleeve',
        '9:30pm - TATTOO of DAY - Sponsored by GOOD GUY SUPPLIES',
      ],
      note: '(Tattoo must be started and finished that day)',
    },
    {
      id: 'monday',
      tabLabel: 'Monday',
      title: 'MONDAY, MAY 18:',
      events: [
        'DOORS - NOON',
        '2pm - Back Piece',
        '3pm - Best Overall Tattoo Collection',
        '5pm - TATTOO of DAY & Best of Show - Sponsored by GOOD GUY SUPPLIES',
      ],
      note: '(Tattoo MUST be done over the weekend of the show)',
    },
  ];

  const activeDay = scheduleDays.find((day) => day.id === activeTab) || scheduleDays[0];

  return (
    <section id="schedule" className="relative text-center font-tattoo p-4 sm:p-6 md:p-8">
      <div className="relative z-10 px-2 sm:px-6 md:px-8 lg:px-24 text-white">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-4 sm:mb-6">Schedule</h1>
        <div className="flex flex-col md:flex-row items-start justify-between gap-6">
          <div className="md:flex-1 bg-white bg-opacity-10 rounded-lg p-4 sm:p-6 md:p-8 text-left space-y-5 sm:space-y-8 w-full">
            <div className="grid grid-cols-3 gap-2">
              {scheduleDays.map((day) => (
                <button
                  key={day.id}
                  type="button"
                  className={`w-full px-2 sm:px-3 py-2 rounded-md text-xs sm:text-sm md:text-base leading-tight transition ${
                    activeTab === day.id
                      ? 'bg-primary text-black'
                      : 'bg-black bg-opacity-40 text-gray-200 hover:bg-primary hover:text-black'
                  }`}
                  onClick={() => setActiveTab(day.id)}
                >
                  {day.tabLabel}
                </button>
              ))}
            </div>

            <div className="min-w-0">
              <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-primary mb-3 leading-tight">{activeDay.title}</h2>
              <ul className="space-y-2 text-sm sm:text-base md:text-lg lg:text-xl text-gray-100">
                {activeDay.events.map((event) => (
                  <li key={event} className="leading-snug break-words">- {event}</li>
                ))}
              </ul>
              <p className="mt-3 text-xs sm:text-sm md:text-base lg:text-lg text-gray-300 leading-snug">{activeDay.note}</p>
            </div>
          </div>

          {/* Logo Section */}
          <div className="w-full md:w-1/3 flex justify-center items-center">
            <div className="w-[60%] sm:w-[45%] md:w-[80%] lg:w-[90%]">
              <a href="https://goodguysupply.com/">
                <img
                  src={imageAssetUrl('logo--goodguy.png')}
                  alt="GoodGuy Tattoo Supply"
                  className="rounded-lg shadow-lg w-full h-auto hover:scale-105 hover:opacity-90 transition duration-300 ease-in-out"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
